var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.success)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"m-index-popup"},[_c('lanternFestival',{attrs:{"fontCount":_vm.count},on:{"close":_vm.closePop}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }